require('../../../modules/es.number.to-fixed');
require('../../../modules/es.number.to-precision');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Number');
